import { render } from "./DisplayAddress.vue?vue&type=template&id=f2b3d5da"
import script from "./DisplayAddress.vue?vue&type=script&lang=js"
export * from "./DisplayAddress.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__